<template>
    <div class=audio-player>


        <div ref="progress" class=progress @click="clickProgress">
            <div class=elapsed :style="{ width : ( progress * 100 ) + '%' }"></div>
            <div class=current :style="{ left : ( progress * 100 ) + '%' }">
                <div class=time>{{ getPrettyTime(seek) }}</div>
            </div>
            <div class=total-time>{{ getPrettyTime(duration) }}</div>
        </div>

        <div class=controls :class="{ 'is-playing' : playing }">
            <button class=play @click="togglePlayback"></button>
            <button class=pause @click="pause"></button>
        </div>

    </div>
</template>
<script>
import VueHowler from 'vue-howler';

export default {
    name   : 'AudioPlayer',
    mixins : [VueHowler]  ,
    methods : {
        getPrettyTime( seconds ) {
            seconds = Number(seconds);
            let h = Math.floor(seconds / 3600);
            let m = Math.floor(seconds % 3600 / 60);
            let s = Math.floor(seconds % 3600 % 60);

            let timeString = '';

            if( h ) {
                timeString += h + ':';
                timeString += m.toString().padStart(2,'0') + ':';
            }
            else {
                timeString += m.toString() + ':';
            }


            timeString += s.toString().padStart(2,'0');

            return timeString;
        },
        clickProgress(e) {
            let gutter = 90;
            let progress = this.$refs.progress;
            let pos = (e.pageX  -  (progress.offsetLeft + progress.offsetParent.offsetLeft + gutter)) / progress.offsetWidth;

            this.setProgress( pos );
        }
    }
}
</script>